export default __webpack_public_path__ + "static/media/referPatientIcon.28454a77.svg";